// General
export { default as whiteRightArrow } from "./images/general/white_right_arrow.svg";
export { default as greyRightArrow } from "./images/general/grey_right_arrow.svg";
export { default as protransLogo } from "./images/general/protransLogo_Blue.png";
export { default as protransLogoWhite } from "./images/general/protransLogo_White.png";
export { default as downArrow } from "./images/general/down_arrow.svg";
export { default as callIcon } from "./images/general/call_icon.png";
export { default as mailIcon } from "./images/general/mail_con.png";
export { default as globeIcon } from "./images/general/globe_icon.png";

// HOMEPAGE IMAGES
export { default as unlocking } from "./images/home/unlocking.png";
export { default as unlockingMb } from "./images/home/unlocking.png";
export { default as card1_bg } from "./images/home/card1_bg.png";
export { default as card1_icon_light } from "./images/home/card_icon1_blue.svg";
export { default as card2_icon_light } from "./images/home/card2_icon_light.svg";
export { default as card3_icon_light } from "./images/home/card3_icon_light.svg";
export { default as card1_icon } from "./images/home/card_1_icon.png";
export { default as card2_icon } from "./images/home/card_2_icon.png";
export { default as card3_icon } from "./images/home/card_3_icon.png";
export { default as card4_img } from "./images/home/card4_img.png";
export { default as grid1_img } from "./images/home/grid_1_img.png";
export { default as grid2_img } from "./images/home/grid2_img.png";
export { default as grid3_img } from "./images/home/grid3_img.png";
export { default as grid4_img } from "./images/home/grid4_img.png";
export { default as grid5_img } from "./images/home/grid5_img.png";
export { default as grid6_img } from "./images/home/grid6_img.png";
export { default as grid7_img } from "./images/home/grid7_img.png";
export { default as grid8_img } from "./images/home/others.png";
export { default as grid9_img } from "./images/home/hazardous.png";
export { default as grid10_img } from "./images/home/aog_support.png";
export { default as accBg } from "./images/home/acc_bg.png";
export { default as keyStrengthBg } from "./images/home/key_strength_bg.png";
export { default as keyStrengthBgMb } from "./images/home/key_strength_bg_mb.png";
export { default as quoteForm } from "./images/home/get_a_quote.png";

// <============================ PRODUCTS LISTING IMAGES ==========================>

export let images = {
  homeBanner01: {
    img: require("./images/home/home_banner01.jpg"),
  },
  homeBannerMb01: {
    img: require("./images/home/home_banner_Mb01.jpg"),
  },
  airFreight: {
    img: require("./images/home/Air_Freight.png"),
  },
  airFreightMb: {
    img: require("./images/home/Air_Freight_mb.png"),
  },
  seaFreight: {
    img: require("./images/home/Sea_Freight.png"),
  },
  seaFreightMb: {
    img: require("./images/home/sea_freight_mb.png"),
  },
  roadTransport: {
    img: require("./images/home/Road_Transport.png"),
  },
  roadTransportMb: {
    img: require("./images/home/road_transpot_mb.png"),
  },
  warehouseStorage: {
    img: require("./images/home/Warehouse_Storage.png"),
  },
  warehouseStorageMb: {
    img: require("./images/home/warehouse_storage_mb.png"),
  },

  chainManagement: {
    img: require("./images/home/end-to-end-supply-chain.png"),
  },
  orderManagement: {
    img: require("./images/home/order-management.png"),
  },
  valueAddedServices: {
    img: require("./images/home/value-added-services.png"),
  },
  scalableSolutions: {
    img: require("./images/home/scalable-solutions.png"),
  },

  optimizedRoute: {
    img: require("./images/home/Optimized_Route.png"),
  },
  optimizedRouteMb: {
    img: require("./images/home/Optimized_Route_Mb.png"),
  },
  energyEfficientWarehousing: {
    img: require("./images/home/Energy_Efficient_Warehousing.jpg"),
  },
  energyEfficientWarehousingMb: {
    img: require("./images/home/Energy_Efficient_Warehousing_Mb.jpg"),
  },

  blueContainer: {
    img: require("./images/home/blue_container.png"),
  },
  blueContainerMb: {
    img: require("./images/home/blue_container_mb.png"),
  },
  skyBlueContainer: {
    img: require("./images/home/sky_blue_container.png"),
  },
  skyBlueContainerMb: {
    img: require("./images/home/sky_blue_container_mb.png"),
  },
};
